import React from 'react';
import FormSkeleton from '../Skeletons/FormSkeleton';

/**
 * Reusable wrapper for forms with loading, error, and glassmorphism styling
 * @param {Object} props
 * @param {boolean} props.isLoading - Whether data is loading
 * @param {Error} props.error - Error object if fetch failed
 * @param {any} props.data - The data to pass to children
 * @param {React.ReactNode} props.children - Form component to render
 * @param {string} props.errorMessage - Custom error message
 * @param {string} props.className - Additional CSS classes
 */
const FormWrapper = ({
  isLoading,
  error,
  data,
  children,
  tabId,
  errorMessage = 'Failed to load data',
  className = '',
}) => {
  // Show skeleton loader while loading
  if (isLoading) {
    return (
      <div
        className={`bg-white/60 backdrop-blur-md rounded-2xl shadow-xl border border-white/20 ${className}`}
        tabId={tabId}
      >
        <FormSkeleton />
      </div>
    );
  }

  // Show error state if there's an error
  if (error) {
    return (
      <div
        className={`bg-white/60 backdrop-blur-md rounded-2xl shadow-xl border border-white/20 p-8 ${className}`}
      >
        <div className='text-center py-8'>
          <p className='text-red-600 font-medium'>{errorMessage}</p>
          {error.message && <p className='text-gray-500 text-sm mt-2'>{error.message}</p>}
        </div>
      </div>
    );
  }

  // Show "no data" state if data is null/undefined
  if (!data) {
    return (
      <div className={`bg-transparent p-8 ${className}`}>
        <div className='text-center py-8'>
          <p className='text-gray-600'>No data available</p>
        </div>
      </div>
    );
  }

  // Render children with data
  return <div className={`bg-transparent ${className}`}>{children}</div>;
};

export default FormWrapper;
